export default __webpack_public_path__ + "static/media/ChristopherLightsey1995.927ea3c8.jpg";